import apiClient from './apiClient';

/**
 * @returns {{ sections: array, iconOptions: string[] }}
 */
export const getPrivacyPolicy = async () => {
  const { data } = await apiClient.get('/api/privacy');
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    return {
      sections: Array.isArray(data.sections) ? data.sections : [],
      iconOptions: Array.isArray(data.iconOptions) && data.iconOptions.length > 0 ? data.iconOptions : [],
    };
  }
  // Legacy: API used to return a bare array of sections
  return {
    sections: Array.isArray(data) ? data : [],
    iconOptions: [],
  };
};

/** @deprecated Use getPrivacyPolicy — kept for any code expecting sections only */
export const getPrivacySections = async () => {
  const { sections } = await getPrivacyPolicy();
  return sections;
};

/**
 * Save privacy CMS. Pass { sections, iconOptions } or legacy array of sections only.
 * @param {array|{ sections: array, iconOptions?: string[] }} payload
 * @returns {{ sections: array, iconOptions: string[] }}
 */
export const savePrivacyPolicy = async (payload) => {
  const body = Array.isArray(payload) ? payload : payload;
  const { data } = await apiClient.put('/api/privacy', body);
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    return {
      sections: Array.isArray(data.sections) ? data.sections : [],
      iconOptions: Array.isArray(data.iconOptions) && data.iconOptions.length > 0 ? data.iconOptions : [],
    };
  }
  return {
    sections: Array.isArray(data) ? data : [],
    iconOptions: [],
  };
};

export const savePrivacySections = async (sections) => savePrivacyPolicy({ sections });
